import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=7caf1cb6&scoped=true"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=7caf1cb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caf1cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7caf1cb6')) {
      api.createRecord('7caf1cb6', component.options)
    } else {
      api.reload('7caf1cb6', component.options)
    }
    module.hot.accept("./EditStaff.vue?vue&type=template&id=7caf1cb6&scoped=true", function () {
      api.rerender('7caf1cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/users/EditStaff.vue"
export default component.exports